module.exports = __webpack_public_path__ + "img/wx4.a3f46349.jpg";